// extracted by mini-css-extract-plugin
export default {"clt_60_13":"styles_clt_60_13__gcndJ","clt_60_12":"styles_clt_60_12__eSAd1"};